/* eslint-disable no-use-before-define */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
// eslint-disable-next-line max-len
// eslint-disable-next-line no-unused-vars
export default function colorpickerAction(initColors, showCursorCoords, isMouseDown, toolState, ctxMain, canvasToCursor, ctxToCursor) {
  let prevX;
  let prevY;
  // let colorToPaint;

  canvasToCursor.addEventListener('contextmenu', (e) => {
    e.preventDefault();
  });

  canvasToCursor.addEventListener('mousedown', (e) => {
    if (toolState.currentToolId === 'colorpicker') {
      ctxToCursor.clearRect(prevX, prevY, 1, 1);
      isMouseDown = true;
      const rgbaArr = ctxMain.getImageData(e.offsetX, e.offsetY, 1, 1).data;
      // const rgba = `rgba(${rgbaArr[0]}, ${rgbaArr[1]}, ${rgbaArr[2]}, ${rgbaArr[3] / 255})`;
      if (rgbaArr[3] !== 0) {
        const hex = RGBToHex(rgbaArr[0], rgbaArr[1], rgbaArr[2]);
        if (e.button === 2) toolState.secondaryColor = hex;
        else toolState.primaryColor = hex;
        initColors(toolState.primaryColor, toolState.secondaryColor);
      }
    }
  });
  canvasToCursor.addEventListener('mouseup', () => {
    if (toolState.currentToolId === 'colorpicker') {
      isMouseDown = false;
    }
  });

  canvasToCursor.addEventListener('mouseout', () => {
    if (toolState.currentToolId === 'colorpicker') {
      ctxToCursor.beginPath();
      ctxToCursor.clearRect(prevX, prevY, 1, 1);
      ctxToCursor.fill();
      showCursorCoords();
    }
  });

  canvasToCursor.addEventListener('mousemove', (e) => {
    if (toolState.currentToolId === 'colorpicker') {
      showCursorCoords(e.offsetX, e.offsetY);
      if (isMouseDown === false) {
        ctxToCursor.beginPath();
        ctxToCursor.clearRect(prevX, prevY, 1, 1);
        ctxToCursor.fill();
        prevX = e.offsetX;
        prevY = e.offsetY;
        ctxToCursor.fillStyle = 'rgba(255,255,255, 0.5)';
        ctxToCursor.fillRect(e.offsetX, e.offsetY, 1, 1);
      }
    }
  });
}

function RGBToHex(r, g, b) {
  r = r.toString(16);
  g = g.toString(16);
  b = b.toString(16);

  if (r.length === 1) r = `0${r}`;
  if (g.length === 1) g = `0${g}`;
  if (b.length === 1) b = `0${b}`;

  return `#${r}${g}${b}`;
}
